import React from 'react';
import { useIsMobile } from '@uplift/hooks';
import { DesktopMessagingContent, DesktopMessagingDialog } from './MessagingModal/DesktopMessagingDialog';
import { MobileMessagingContent, MobileMessagingDialog } from './MessagingModal/MobileMessagingDialog';


export const PatientDesktopMessagingModal: React.FC = () => {
  return (
    <DesktopMessagingDialog>
      <DesktopMessagingContent color="primary" />
    </DesktopMessagingDialog>
  );
};


export const PatientMobileMessagingModal: React.FC = () => {
  return (
    <MobileMessagingDialog>
      <MobileMessagingContent color="primary" />
    </MobileMessagingDialog>
  );
};


export const PatientMessagingModal: React.FC = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <PatientMobileMessagingModal />;
  }

  return <PatientDesktopMessagingModal />;
};
